import React from "react"
import AppRoute from "./routes/AppRoute"
import './App.css';

const App: React.FC = () => {
  return (
    <AppRoute />
  )
}

export default App;
